import React from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import { exterieur1 } from '../assets/images';

const NeighborhoodPage: React.FC = () => {
  return (
    <NeighborhoodPageContainer>
      <HeroSection>
        <HeroOverlay />
        <HeroContent>
          <h1>Le Quartier</h1>
          <p>Découvrez les environs de la Villa Leïs Auro</p>
        </HeroContent>
      </HeroSection>

      <Section light>
        <div className="container">
          <SectionTitle>
            <h2>Le Quartier</h2>
          </SectionTitle>
          <NeighborhoodContent>
            <NeighborhoodSection>
              <h3>À découvrir aux alentours (à pied ou à 10 minutes en voiture maximum) :</h3>
              <NeighborhoodList>
                <NeighborhoodItem>Randonnées à vélo/VTT ou à pied, idéales pour explorer les paysages naturels environnants.</NeighborhoodItem>
                <NeighborhoodItem>Pumptrack pour les amateurs de sensations fortes.</NeighborhoodItem>
                <NeighborhoodItem>Équitation pour découvrir la région à cheval.</NeighborhoodItem>
                <NeighborhoodItem>Dégustations de produits locaux, dont des vins et huiles d'olive.</NeighborhoodItem>
                <NeighborhoodItem>Visites de domaines viticoles pour une immersion dans la culture provençale.</NeighborhoodItem>
                <NeighborhoodItem>Visite du moulin à huile, un véritable voyage dans le temps pour découvrir la fabrication de l'huile d'olive.</NeighborhoodItem>
                <NeighborhoodItem>Bien sûr, la visite de notre joyau naturel, les Gorges de Pennafort, un site spectaculaire pour les amoureux de nature et de randonnée.</NeighborhoodItem>
              </NeighborhoodList>
            </NeighborhoodSection>

            <NeighborhoodSection>
              <h3>Les sorties à moins d'une demi-heure en voiture :</h3>
              <NeighborhoodList>
                <NeighborhoodItem>Visites de châteaux médiévaux pour plonger dans l'histoire de la région.</NeighborhoodItem>
                <NeighborhoodItem>Sorties sportives variées, incluant : Escalade, Parapente, Accrobranche, Sports nautiques (notamment le kayak, le paddle et la voile), Golf.</NeighborhoodItem>
              </NeighborhoodList>
            </NeighborhoodSection>

            <NeighborhoodSection>
              <h3>Les sorties un peu plus éloignées (entre 45 minutes et 1 heure en voiture) :</h3>
              <NeighborhoodList>
                <NeighborhoodItem>Les plages de la Côte d'Azur (à 45 minutes), pour profiter du soleil et de la mer méditerranéenne.</NeighborhoodItem>
                <NeighborhoodItem>Le Lac de Saint-Cassien (50 minutes), parfait pour une journée de détente en famille ou entre amis.</NeighborhoodItem>
                <NeighborhoodItem>Les Gorges du Verdon (50 minutes), un site incontournable pour les passionnés de nature et de sports d'eau vive.</NeighborhoodItem>
                <NeighborhoodItem>Le Lac de Castillon (50 minutes), idéal pour les activités nautiques et les balades en bord de lac.</NeighborhoodItem>
                <NeighborhoodItem>Grasse (50 minutes), la capitale mondiale du parfum, à découvrir pour ses musées et ses ateliers.</NeighborhoodItem>
                <NeighborhoodItem>Saint-Tropez (1h), célèbre pour ses plages, son port de plaisance et son ambiance festive.</NeighborhoodItem>
              </NeighborhoodList>
            </NeighborhoodSection>
          </NeighborhoodContent>
        </div>
      </Section>

      <Section>
        <div className="container">
          <SectionTitle>
            <h2>Se Déplacer</h2>
          </SectionTitle>
          <TransportContent>
            <p>Pour se déplacer autour de Callas, plusieurs options sont disponibles :</p>
            <TransportList>
              <TransportItem>
                <TransportIcon>🚗</TransportIcon>
                <TransportText>
                  <strong>Voiture</strong>
                  <p>C'est le moyen de transport le plus pratique pour explorer les environs. La région offre un bon réseau de routes, et avoir une voiture permet d'accéder facilement aux villages voisins, aux sites touristiques et aux paysages naturels.</p>
                </TransportText>
              </TransportItem>
              <TransportItem>
                <TransportIcon>🚆</TransportIcon>
                <TransportText>
                  <strong>Train</strong>
                  <p>25 minutes de la Gare TGV des Arcs – Draguignan (ligne TGV directe de Paris) ; 1h de l'Aéroport Nice Côte d'Azur ; 1h30 de la Gare d'Aix en Provence TGV ; 1h30 de la Gare de Marseille Saint Charles.</p>
                </TransportText>
              </TransportItem>
              <TransportItem>
                <TransportIcon>🚲</TransportIcon>
                <TransportText>
                  <strong>Vélo</strong>
                  <p>Pour les amateurs de cyclisme, les routes et les sentiers environnants sont propices aux balades à vélo, permettant de découvrir la beauté de la campagne à un rythme tranquille. A moins de 200m de l'Eurovélo 8 et du Col de Boussaque.</p>
                </TransportText>
              </TransportItem>
              <TransportItem>
                <TransportIcon>🚶</TransportIcon>
                <TransportText>
                  <strong>À pied</strong>
                  <p>Dans le village de Callas, de nombreux commerces et restaurants sont accessibles à pied, ce qui est agréable pour explorer le charmant centre du village. Vous pourrez également profiter de balades entre oliviers, pins et cyprès, dans un véritable environnement provençal, bercé par le chant des cigales et des oiseaux, pour une immersion totale dans la nature locale.</p>
                </TransportText>
              </TransportItem>
            </TransportList>
          </TransportContent>
        </div>
      </Section>

      <CtaSection>
        <CtaOverlay />
        <div className="container">
          <CtaContent>
            <h2>Prêt à réserver votre séjour de rêve ?</h2>
            <p>Vérifiez la disponibilité et réservez dès maintenant pour profiter de notre villa de luxe.</p>
            <CtaButtons>
              <Button to="/availability" size="large">
                Vérifier les disponibilités
              </Button>
              <Button to="/contact" size="large">
                Nous contacter
              </Button>
            </CtaButtons>
          </CtaContent>
        </div>
      </CtaSection>
    </NeighborhoodPageContainer>
  );
};

const NeighborhoodPageContainer = styled.div``;

const HeroSection = styled.section`
  position: relative;
  height: 60vh;
  min-height: 500px;
  background-image: url(${exterieur1});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
`;

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 800px;
  padding: 0 2rem;
  
  h1 {
    font-size: 4.8rem;
    margin-bottom: 2rem;
    font-family: var(--font-secondary);
    color: white;
    
    @media (max-width: 768px) {
      font-size: 3.6rem;
    }
  }
  
  p {
    font-size: 2rem;
    margin-bottom: 3rem;
    
    @media (max-width: 768px) {
      font-size: 1.8rem;
    }
  }
`;

interface SectionProps {
  light?: boolean;
}

const Section = styled.section<SectionProps>`
  padding: 8rem 0;
  background-color: ${({ light }) => light ? 'var(--color-light)' : 'white'};
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 5rem;
  
  h2 {
    font-size: 3.6rem;
    position: relative;
    display: inline-block;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -1.5rem;
      left: 50%;
      transform: translateX(-50%);
      width: 8rem;
      height: 3px;
      background-color: var(--color-accent);
    }
  }
`;

const NeighborhoodContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const NeighborhoodSection = styled.div`
  margin-bottom: 4rem;
  
  h3 {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    color: var(--color-primary);
    position: relative;
    padding-left: 2rem;
    
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.8rem;
      width: 1rem;
      height: 1rem;
      background-color: var(--color-accent);
      border-radius: 50%;
    }
  }
`;

const NeighborhoodList = styled.ul`
  list-style: none;
`;

const NeighborhoodItem = styled.li`
  position: relative;
  padding-left: 2.5rem;
  margin-bottom: 1.5rem;
  font-size: 1.6rem;
  line-height: 1.6;
  color: var(--color-secondary);
  
  &:before {
    content: '✓';
    position: absolute;
    left: 0;
    color: var(--color-accent);
    font-weight: bold;
  }
`;

const TransportContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  
  > p {
    font-size: 1.8rem;
    margin-bottom: 3rem;
    text-align: center;
    color: var(--color-secondary);
  }
`;

const TransportList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;

const TransportItem = styled.div`
  display: flex;
  gap: 2rem;
  background-color: var(--color-light);
  padding: 2.5rem;
  border-radius: 8px;
  box-shadow: var(--shadow);
`;

const TransportIcon = styled.div`
  font-size: 3rem;
  flex-shrink: 0;
`;

const TransportText = styled.div`
  strong {
    display: block;
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: var(--color-primary);
  }
  
  p {
    font-size: 1.5rem;
    color: var(--color-secondary);
    line-height: 1.6;
  }
`;

const CtaSection = styled.section`
  position: relative;
  padding: 8rem 0;
  background-image: url(${exterieur1});
  background-size: cover;
  background-position: center;
  color: white;
  text-align: center;
`;

const CtaOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
`;

const CtaContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  
  h2 {
    font-size: 3.6rem;
    margin-bottom: 2rem;
    color: white;
  }
  
  p {
    font-size: 1.8rem;
    margin-bottom: 3rem;
  }
`;

const CtaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;

export default NeighborhoodPage;
